import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Row } from "simple-flexbox";
import CheckIcon from "@material-ui/icons/Check";
import { StyleSheet, css } from "aphrodite";
import Button from "@material-ui/core/Button";
import { universityList } from "../../actions/master-data/university_action";
import {
  getUniversityListPending,
  getUniversityList,
  getUniversityListError,
} from "../../reducers/master-data/university_reducer";
import { interestList } from "../../actions/master-data/interest_action.js";
import {
  getInterestListPending,
  getInterestList,
  getInterestListError,
} from "../../reducers/master-data/interest_reducer";

import { registrationList } from "../../actions/registrasi_sp2/registrasi_action";
import {
  getRegistrationListPending,
  getRegistrationList,
  getRegistrationListError,
} from "../../reducers/registrasi_sp2/registrasi_reducer";
import { editPpds } from "../../actions/member/ppds_sp2_action";
import {
  getEditPpds,
  getEditPpdsPending,
  getEditPpdsError,
} from "../../reducers/member/ppds_reducer";
import LabelInputVerticalComponent from "../../components/global-components/LabelInputVerticalComponent";
import SelectComponent from "../../components/form/SelectComponent";
import { connect } from "react-redux";

class ModalEditPeminatan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedInterest: this.props.interest,
    };
    this.handleChangeInterest = this.handleChangeInterest.bind(this);
    this.editPeminatanTujuan = this.editPeminatanTujuan.bind(this);
  }

  handleChangeInterest(e) {
    if (e !== null) {
      this.setState({ selectedInterest: e.value });
    } else {
      this.setState({ selectedInterest: "" });
    }
  }

  editPeminatanTujuan() {
    const { editPpds, onHide, registrationList } = this.props;
    const param_editPeminatanTujuan = {
      id: this.props.id,
      email: this.props.email,
      name: this.props.name,
      university_before: this.props.university_before,
      graduated: this.props.graduated,
      birthday: this.props.birthday,
      place_of_birth: this.props.place_of_birth,
      address: this.props.address,
      handphone: this.props.handphone,
      npa_idi: this.props.npa_idi,
      ip_s1: this.props.ip_s1,
      ip_profesi: this.props.ip_profesi,
      ip_cumulation: this.props.ip_cumulation,
      notes: this.props.notes,
      kolegium_no: this.props.kolegium_no,
      working_hospital_1: this.props.working_hospital_1,
      working_hospital_2: this.props.working_hospital_2,
      working_hospital_3: this.props.working_hospital_3,
      destination_universities: [
        {
          id: this.props.id,
          university_id: this.props.prodi,
          period_selection_month: this.props.bulan,
          period_selection_year: this.props.tahun,
          interest:
            this.state.selectedInterest !== ""
              ? this.state.selectedInterest
              : this.props.interest,
        },
      ],
    };
    const callback = () => {
      onHide();
      let param_registrationList = {
        id: this.props.id,
      };
      registrationList(param_registrationList);
    };
    editPpds(param_editPeminatanTujuan, callback, null, "edit_peminatan");
  }

  componentDidMount() {
    let param_interestList = {
      page: 1,
      length: 10,
      id: "",
    };
    this.props.interestList(param_interestList);
    let param_registrationList = {
      id: this.props.id,
    };
    this.props.registrationList(param_registrationList);
  }

  render() {
    const { interestList_data, registrationList_data } = this.props;
    let peminatanOption = [];
    let userPeminatanLabel = "";
    let userPeminatanID = "";
    let userProdiAbbreviation = "";
    if (interestList_data) {
      let data = interestList_data;
      peminatanOption = data.map((value, index) => {
        const interesting = {
          value: value.name,
          label: value.name,
        };
        return interesting;
      });
    }
    if (registrationList_data) {
      let registrationData = registrationList_data.data[0];
      userPeminatanLabel =
        registrationData.ppds_destination_university_data[0].interest;
      userPeminatanID = registrationData.ppds_destination_university_data[0].id;
      userProdiAbbreviation =
        registrationData.ppds_destination_university_data[0].university_data
          .abbreviation;
    }

    let peminatanOptionsFKUNAIR;
    if (userProdiAbbreviation === "FKUNAIR") {
      const allowedValues = [
        "Orthopaedi Tulang Belakang",
        "Panggul dan Lutut",
        "Tangan, Lengan dan Bedah Mikro",
        "Onkologi Orthopaedi dan Rekonstruksi",
        "Anak",
      ];
      peminatanOptionsFKUNAIR = peminatanOption.filter((option) =>
        allowedValues.includes(option.label)
      );
    }
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        id={this.props.id}
        prodi={this.props.prodi}
        interest={this.props.interest}
        bulan={this.props.bulan}
        tahun={this.props.tahun}
        email={this.props.email}
        name={this.props.name}
        university_before={this.props.university_before}
        graduated={this.props.graduated}
        birthday={this.props.birthday}
        place_of_birth={this.props.place_of_birth}
        address={this.props.address}
        handphone={this.props.handphone}
        npa_idi={this.props.npa_idi}
        notes={this.props.notes}
        working_hospital_1={this.props.working_hospital_1}
        working_hospital_2={this.props.working_hospital_2}
        working_hospital_3={this.props.working_hospital_3}
        dialogClassName="modal-width"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <p style={{ fontSize: 20, fontWeight: 600, marginBottom: 50 }}>
            Peminatan yang dituju
          </p>
        </Modal.Header>
        <Modal.Body>
          <Row className={css(styles.bodyModal)}>
            <LabelInputVerticalComponent label="Peminatan" width="600px">
              <SelectComponent
                isClearable={false}
                placeholder="Peminatan Tujuan"
                options={
                  userProdiAbbreviation === "FKUNAIR"
                    ? peminatanOptionsFKUNAIR
                    : peminatanOption
                }
                onChange={this.handleChangeInterest}
                defaultValue={{
                  value: userPeminatanID,
                  label: userPeminatanLabel,
                }}
                id="interest"
              />
            </LabelInputVerticalComponent>
          </Row>
          <Row
            horizontal="flex-end"
            vertical="center"
            className={css(styles.footerModal)}
          >
            <Button
              variant="contained"
              color="primary"
              className={css(styles.approveButton)}
              startIcon={<CheckIcon />}
              onClick={() => this.editPeminatanTujuan()}
            >
              SIMPAN
            </Button>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
  rejectButton: {
    background: "#EAEBED 0% 0% no-repeat padding-box",
    marginRight: 10,
    color: "#495057",
    boxShadow: "none",
  },
  footerModal: {
    marginTop: 20,
    backgroundColor: "#FBFBFD",
    height: 80,
    paddingLeft: 40,
    paddingRight: 40,
  },
  bodyModal: {
    paddingLeft: 40,
    paddingRight: 40,
  },
});

function mapStateToProps({
  universityList,
  interestList,
  registrationList,
  editPpds,
}) {
  return {
    universityList_pending: getUniversityListPending(universityList),
    universityList_data: getUniversityList(universityList),
    universityList_error: getUniversityListError(universityList),
    interestList_pending: getInterestListPending(interestList),
    interestList_data: getInterestList(interestList),
    interestList_error: getInterestListError(interestList),
    registrationList_pending: getRegistrationListPending(registrationList),
    registrationList_data: getRegistrationList(registrationList),
    registrationList_error: getRegistrationListError(registrationList),
    editPpds_pending: getEditPpdsPending(editPpds),
    editPpds_data: getEditPpds(editPpds),
    editPpds_error: getEditPpdsError(editPpds),
  };
}

export default connect(mapStateToProps, {
  universityList,
  interestList,
  registrationList,
  editPpds,
})(ModalEditPeminatan);
